module.exports = __webpack_public_path__ + "img/jch3.df834653.jpg";